import React from 'react';
import { FormControl, Grid, MenuItem, Select } from '@mui/material';
import SearchFilter from '../../../components/filters/SearchFilter';
import { usePermissions } from '../../../hooks/usePermissions';
import { READ_SALE_INVOICE, READ_PURCHASE_INVOICE } from '../../../constants/eInvoicePermissions';
import PermissionDeniedWrapper from "../../../components/PermissionDeniedWrapper";
import {hasEInvoicePermission} from "../../../utils/permissions";
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import { Tooltip } from '@mui/material';

const BulkUploadListFilters = ({
  filters,
  selectedFilter,
  selectedStatus,
  selectedCategory,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  onStatusChange,
  onCategoryChange
}) => {
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();


  const categoryFilterOptions = ['', 'E_INVOICE SALES', 'E_INVOICE PURCHASES'];
  const getCategoryPermission = (option) => {
    switch (option) {
      case 'E_INVOICE SALES':
        return hasEInvoicePermission(READ_SALE_INVOICE);

      case 'E_INVOICE PURCHASES':
        return hasEInvoicePermission(READ_PURCHASE_INVOICE);

      case '':
      default:
        return true;
    }
  };
  const CATEGORY_OPTION_LABELS = {
    '': {
      key: 'all_category',
      fallback: 'All Category',
    },
    'E_INVOICE SALES': {
      key: 'sales_invoice',
      fallback: 'Sales Documents',
    },
    'E_INVOICE PURCHASES': {
      key: 'self_billed_invoice',
      fallback: 'Purchase Documents',
    },
  }
  const handleCategoryChange = (event) => {
    const selectedCategory = event.target.value;

    if (!getCategoryPermission(selectedCategory)) {
      return;
    }

    onCategoryChange(event);
  };

  const renderCategoryOption = (option) => {
    const labelConfig = CATEGORY_OPTION_LABELS[option] ?? {
      fallback: option,
    };

    const hasPermission = getCategoryPermission(option);

    return (
        <MenuItem
            key={option}
            value={option}
            disabled={!hasPermission}
            sx={{
              '&.Mui-disabled': {
                pointerEvents: 'auto',
                cursor: 'not-allowed',
              },
            }}
        >
          <PermissionDeniedWrapper show={!hasPermission} title={accessDeniedMessage} placement="right" fullWidth>
          <span
              style={{
                display: 'block',
                width: '100%',
                cursor: 'pointer',
              }}
          >
            {labelConfig.fallback}
          </span>
          </PermissionDeniedWrapper>
        </MenuItem>
    );
  };

  const renderFilter = (filter) => {
    switch (filter.type) {
      case 'search':
        return (
          <SearchFilter
            key={filter.type}
            filter={filter}
            selectedFilter={selectedFilter}
            onFilterChange={onFilterChange}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            onSearchKeyPress={onSearchKeyPress}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Grid item xs={12} sx={{ padding: '2px' }} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid item xs={12} sx={{ mb: 2 , rowGap: '5px'}}>
        <FormControl sx={{ padding: '1px', minWidth: 140}}>
          <Select
            value={selectedStatus}
            onChange={onStatusChange}
            displayEmpty
            size="small"
            sx={{ fontSize: '0.875rem', padding: '1px' }}
            variant="outlined"
          >
            <MenuItem key="default" value={''}>
              {'All Status'}
            </MenuItem>
            <MenuItem key="uploaded" value={'UPLOADED'}>
              {'Queued'}
            </MenuItem>
            <MenuItem key="processing" value={'PROCESSING'}>
              {'Processing'}
            </MenuItem>
            <MenuItem key="completed" value={'COMPLETED'}>
              {'Processed'}
            </MenuItem>
            <MenuItem key="upload_failed" value={'UPLOAD_FAILED'}>
              {'Failed'}
            </MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ padding: '1px', minWidth: 140, ml: '6px' }}>
          <Select
              value={selectedCategory}
              onChange={handleCategoryChange}
              displayEmpty
              size="small"
              variant="outlined"
              sx={{ fontSize: '0.875rem', padding: '1px' }}
          >
            {categoryFilterOptions.map(renderCategoryOption)}
          </Select>
        </FormControl>
      </Grid>
      <Grid item container spacing={1} justifyContent="flex-end">
        {filters.map((filter) => renderFilter(filter))}
      </Grid>
    </Grid>
  );
};

export default BulkUploadListFilters;
